import { defineComponent } from 'vue'

import { CsModal } from '@sunrise/components'

export default defineComponent({
    name: 'MsDetailModalImprint',
    components: {
        CsModal,
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        imprint: {
            type: String,
            required: true,
        },
    },
    emits: ['closeModal'],
    setup(props, { emit }) {
        function emitClosedModalEvent() {
            emit('closeModal')
        }

        return {
            emitClosedModalEvent,
        }
    },
})
